// src/api/twoFactorService.js
import api, { publicApi } from "./api";

const BASE = "/2fa";

/**
 * 🔐 SETUP 2FA
 * POST /api/2fa/setup
 * Authorization: Bearer JWT
 * → returns PNG QR
 */
const setup2FA = async () => {
    const res = await api.post(`${BASE}/setup`);

    const base64 = res.data.qrCodeBase64;

    return `data:image/png;base64,${base64}`;
};
/**
 * 🔐 CONFIRM 2FA (enable)
 * POST /api/2fa/confirm
 * Authorization: Bearer JWT
 */
const confirm2FA = async (code) => {
    const res = await api.post(`${BASE}/confirm`, { code });
    return res.data;
};

/**
 * 🔓 VERIFY 2FA (LOGIN FLOW)
 * POST /api/2fa/verify
 * ❗ NO JWT HERE
 */
const verify2FA = async (userId, code) => {
    const res = await publicApi.post(`${BASE}/verify`, {
        userId,
        code,
    });

    return res.data; // { token }
};

/**
 * 🔐 DISABLE 2FA
 * POST /api/2fa/disable
 * Authorization: Bearer JWT
 */
const disable2FA = async () => {
    const res = await api.post(`${BASE}/disable`);
    return res.data;
};

export default {
    setup2FA,
    confirm2FA,
    verify2FA,
    disable2FA,
};
